import createStore from "astrid-helpers/src/createStore";

export const [getAutomation, setAutomation, useAutomation] = createStore(true);
